// Atalhos e gestos (tecla ?) — o modal do edvid, com os atalhos das três abas.
import type { ReactNode } from 'react';
import { IconClose } from './icons';

const K = ({ children }: { children: string }) => (
  <kbd className="rounded-md border border-white/15 bg-white/10 px-1.5 py-0.5 font-mono text-[10px] font-bold text-slate-100">{children}</kbd>
);

const ROWS: Array<[ReactNode, ReactNode]> = [
  [<K key="k">espaço</K>, 'play / pause'],
  [<span key="k" className="flex gap-1"><K>←</K><K>→</K></span>, <>frame a frame · com <K>shift</K>, 1 segundo</>],
  [<K key="k">M</K>, <>marca <b>IN</b>, depois <b>OUT</b> — aí escreva o ajuste</>],
  [<K key="k">delete</K>, 'remove o take selecionado (o fantasma fica; delete de novo restaura)'],
  ['arrastar', <>as <b>bordas</b> de um take ajustam o corte</>],
  ['duplo-clique', 'num take desfaz o ajuste dele'],
  [<span key="k" className="flex gap-1"><K>Ctrl</K><K>Z</K></span>, 'desfaz na aba Final (Ctrl+Shift+Z refaz)'],
  [<span key="k" className="flex gap-1"><K>Ctrl</K><K>Enter</K></span>, 'salva a marcação aberta'],
  ['pinça / Ctrl+roda', 'zoom no trackpad, onde está o cursor'],
  ['barra de zoom', 'amplia a partir da agulha'],
  [<K key="k">Esc</K>, 'cancela o IN aberto ou fecha este painel'],
];

export function HelpModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-[2147483300] flex items-center justify-center bg-slate-950/60 p-4" onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div role="dialog" aria-label="Atalhos e gestos" className="w-full max-w-md rounded-2xl border border-white/10 bg-slate-900 p-5 shadow-2xl">
        <div className="mb-3 flex items-center justify-between">
          <p className="text-[10px] font-black uppercase tracking-[0.14em] text-slate-400">Atalhos e gestos</p>
          <button type="button" onClick={onClose} className="rounded-lg p-1.5 text-slate-400 hover:bg-white/10" aria-label="Fechar"><IconClose /></button>
        </div>
        <ul className="space-y-2">
          {ROWS.map(([k, v], i) => (
            <li key={i} className="grid grid-cols-[120px_1fr] items-center gap-3 text-xs text-slate-300">
              <span className="text-[11px] font-semibold text-slate-400">{k}</span>
              <span>{v}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
